module.exports = __webpack_public_path__ + "static/wp1-1-7f0734b2bef8d4c4b09fc7151d159790.jpg";